/* eslint-disable camelcase */

import type { EarlyRepayType, RepayPaymentMethod } from './analytics-types'

export const ANALYTICS_EVENTS = {
  // Customer
  LOGOUT: 'logout',
  OPEN_SUPPORT_CHAT: 'openSupportChat',
  REGISTRATION_DROP: 'registrationDrop',
  PAYMENT_ACTIONS: 'payment actions',
  MERCHANT_BENEFIT_MODAL_OPEN: 'modal-open',
  MERCHANT_BENEFIT_DEAL_CLICK: 'deal-click',
  // PSP
  FORM_CONTINUE: 'formContinue',
  // PSP BNPL CZ checkout
  PSP_CONTACT_SCREEN_VIEW: 'PSP_CONTACT_SCREEN_VIEW',
  PSP_CONTACT_CONTINUE_BUTTON_CLICK: 'PSP_CONTACT_CONTINUE_BUTTON_CLICK',
  PSP_CONTACT_ERROR_BANNER_SHOWN: 'PSP_CONTACT_ERROR_BANNER_SHOWN',
  PSP_PERSONAL_INFO_SCREEN_VIEW: 'PSP_PERSONAL_INFO_SCREEN_VIEW',
  PSP_PERSONAL_INFO_CONTINUE_BUTTON_CLICK:
    'PSP_PERSONAL_INFO_CONTINUE_BUTTON_CLICK',
  PSP_ADDRESS_SCREEN_VIEW: 'PSP_ADDRESS_SCREEN_VIEW',
  PSP_ADDRESS_CONTINUE_BUTTON_CLICK: 'PSP_ADDRESS_CONTINUE_BUTTON_CLICK',
  PSP_VERIFICATION_CHOICE_SCREEN_VIEW: 'PSP_VERIFICATION_CHOICE_SCREEN_VIEW',
  PSP_VERIFICATION_CHOICE_BANK_ID_BUTTON_CLICK:
    'PSP_VERIFICATION_CHOICE_BANK_ID_BUTTON_CLICK',
  PSP_VERIFICATION_CHOICE_ID_SCAN_BUTTON_CLICK:
    'PSP_VERIFICATION_CHOICE_ID_SCAN_BUTTON_CLICK',
  PSP_BANK_ID_REDIRECT: 'PSP_BANK_ID_REDIRECT',
  PSP_BANK_ID_CALLBACK: 'PSP_BANK_ID_CALLBACK',
  PSP_BANK_ID_ERROR_SCREEN_VIEW: 'PSP_BANK_ID_ERROR_SCREEN_VIEW',
  PSP_BANK_ID_ERROR_TRY_AGAIN_BUTTON_CLICK:
    'PSP_BANK_ID_ERROR_TRY_AGAIN_BUTTON_CLICK',
  PSP_ID_SCAN_START: 'PSP_ID_SCAN_START',
  PSP_ID_SCAN_COMPLETE: 'PSP_ID_SCAN_COMPLETE',
  PSP_CREDIT_CHECK_START: 'PSP_CREDIT_CHECK_START',
  PSP_CREDIT_CHECK_COMPLETE: 'PSP_CREDIT_CHECK_COMPLETE',
  PSP_LEGAL_DOCS_SCREEN_VIEW: 'PSP_LEGAL_DOCS_SCREEN_VIEW',
  PSP_LEGAL_DOCS_DOCUMENT_CLICK: 'PSP_LEGAL_DOCS_DOCUMENT_CLICK',
  PSP_LEGAL_DOCS_CHECKBOX_CHECK: 'PSP_LEGAL_DOCS_CHECKBOX_CHECK',
  PSP_LEGAL_DOCS_SELECT_ALL_CLICK: 'PSP_LEGAL_DOCS_SELECT_ALL_CLICK',
  PSP_LEGAL_DOCS_AGREE_BUTTON_CLICK: 'PSP_LEGAL_DOCS_AGREE_BUTTON_CLICK',
  PSP_LEGAL_DOCS_LOAD_ERROR: 'PSP_LEGAL_DOCS_LOAD_ERROR',
  PSP_CONTRACT_CONCLUDED: 'PSP_CONTRACT_CONCLUDED',
  PSP_SUCCESS_SCREEN_VIEW: 'PSP_SUCCESS_SCREEN_VIEW',
  PSP_CHECKOUT_ABANDONED: 'PSP_CHECKOUT_ABANDONED',
  PSP_CHECKOUT_WELCOME_SCREEN_VIEW: 'CHECKOUT_WELCOME_SCREEN_VIEW',
  PSP_CHECKOUT_WELCOME_LEARN_MORE_LINK_CLICK:
    'CHECKOUT_WELCOME_LEARN_MORE_LINK_CLICK',
  PSP_CHECKOUT_WELCOME_CONTACT_US_LINK_CLICK:
    'CHECKOUT_WELCOME_CONTACT_US_LINK_CLICK',
  PSP_CHECKOUT_WELCOME_PAY_BUTTON_CLICK: 'CHECKOUT_WELCOME_PAY_BUTTON_CLICK',
  PSP_CHECKOUT_WELCOME_BACK_TO_SHOP_BUTTON_CLICK:
    'CHECKOUT_WELCOME_BACK_TO_SHOP_BUTTON_CLICK',
  PSP_CHECKOUT_CONFIRM_PAY_SCREEN_VIEW: 'CHECKOUT_CONFIRM_PAY_SCREEN_VIEW',
  PSP_CHECKOUT_CONFIRM_PAY_IDENTITY_EDIT_BUTTON_CLICK:
    'CHECKOUT_CONFIRM_PAY_IDENTITY_EDIT_BUTTON_CLICK',
  PSP_CHECKOUT_CONFIRM_PAY_CONTACT_EDIT_BUTTON_CLICK:
    'CHECKOUT_CONFIRM_PAY_CONTACT_EDIT_BUTTON_CLICK',
  PSP_CHECKOUT_CONFIRM_PAY_SAVE_BUTTON_CLICK:
    'CHECKOUT_CONFIRM_PAY_SAVE_BUTTON_CLICK',
  PSP_CHECKOUT_CONFIRM_PAY_ERROR_BANNER_SHOWN:
    'CHECKOUT_CONFIRM_PAY_ERROR_BANNER_SHOWN',
  PSP_CHECKOUT_CONFIRM_PAY_CONSENTS_EXPANDER_BUTTON_CLICK:
    'CHECKOUT_CONFIRM_PAY_CONSENTS_EXPANDER_BUTTON_CLICK',
  PSP_CHECKOUT_CONFIRM_PAY_CONSENT_CHECK: 'CHECKOUT_CONFIRM_PAY_CONSENT_CHECK',
  PSP_CHECKOUT_CONFIRM_PAY_CONFIRM_BUTTON_CLICK:
    'CHECKOUT_CONFIRM_PAY_CONFIRM_BUTTON_CLICK',
  PSP_CHECKOUT_APP_HANDOFF_OPEN_IN_APP_MODAL_SHOWN:
    'CHECKOUT_APP_HANDOFF_OPEN_IN_APP_MODAL_SHOWN',
  PSP_CHECKOUT_APP_HANDOFF_RESULT_API_RESPONSE:
    'CHECKOUT_APP_HANDOFF_RESULT_API_RESPONSE',
  PSP_CHECKOUT_PAYMENT_PLAN_AMOUNT_INFO_BUTTON_CLICK:
    'CHECKOUT_PAYMENT_PLAN_AMOUNT_INFO_BUTTON_CLICK',
  PSP_CHECKOUT_PAYMENT_PLAN_GOT_IT_BUTTON_CLICK:
    'CHECKOUT_PAYMENT_PLAN_GOT_IT_BUTTON_CLICK',
  PSP_CHECKOUT_PHONE_OTP_SCREEN_VIEW: 'CHECKOUT_PHONE_OTP_SCREEN_VIEW',
  PSP_CHECKOUT_PHONE_OTP_CONTINUE_BUTTON_CLICK:
    'CHECKOUT_PHONE_OTP_CONTINUE_BUTTON_CLICK',
  PSP_CHECKOUT_PHONE_OTP_RESEND_CODE_BUTTON_CLICK:
    'CHECKOUT_PHONE_OTP_RESEND_CODE_BUTTON_CLICK',
  PSP_CHECKOUT_PHONE_OTP_ERROR_BANNER_SHOWN:
    'CHECKOUT_PHONE_OTP_ERROR_BANNER_SHOWN',
  PSP_CHECKOUT_PESEL_SCREEN_VIEW: 'CHECKOUT_PESEL_SCREEN_VIEW',
  PSP_CHECKOUT_PESEL_CONFIRM_BUTTON_CLICK:
    'CHECKOUT_PESEL_CONFIRM_BUTTON_CLICK',
  PSP_CHECKOUT_PESEL_VALIDATION_ERROR_BANNER_SHOWN:
    'CHECKOUT_PESEL_VALIDATION_ERROR_BANNER_SHOWN',
  PSP_CHECKOUT_PESEL_VERIFICATION_API_RESPONSE:
    'CHECKOUT_PESEL_VERIFICATION_API_RESPONSE',
  PSP_CHECKOUT_SCORING_API_RESPONSE: 'CHECKOUT_SCORING_API_RESPONSE',
  PSP_CHECKOUT_SUCCESS_SCREEN_VIEW: 'CHECKOUT_SUCCESS_SCREEN_VIEW',
  PSP_CHECKOUT_SUCCESS_START_FREE_TRIAL_BUTTON_CLICK:
    'CHECKOUT_SUCCESS_START_FREE_TRIAL_BUTTON_CLICK',
  PSP_CHECKOUT_SUCCESS_NOT_THIS_TIME_BUTTON_CLICK:
    'CHECKOUT_SUCCESS_NOT_THIS_TIME_BUTTON_CLICK',
  PSP_CHECKOUT_REJECTION_SCREEN_VIEW: 'CHECKOUT_REJECTION_SCREEN_VIEW',
  PSP_CHECKOUT_FLOW_CLOSE_BUTTON_CLICK: 'CHECKOUT_FLOW_CLOSE_BUTTON_CLICK',
  PSP_CHECKOUT_FLOW_BACK_BUTTON_CLICK: 'CHECKOUT_FLOW_BACK_BUTTON_CLICK',
  PSP_CHECKOUT_SESSION_ABANDONED: 'CHECKOUT_SESSION_ABANDONED',
  // Account — invoice division
  ACCOUNT_DIVIDE_LINK_SHOWN: 'ACCOUNT_DIVIDE_LINK_SHOWN',
  ACCOUNT_DIVIDE_LINK_CLICK: 'ACCOUNT_DIVIDE_LINK_CLICK',
  ACCOUNT_INSTALLMENT_PREVIEW_MODAL_SHOWN:
    'ACCOUNT_INSTALLMENT_PREVIEW_MODAL_SHOWN',
  ACCOUNT_INSTALLMENT_PREVIEW_CONTINUE_BUTTON_CLICK:
    'ACCOUNT_INSTALLMENT_PREVIEW_CONTINUE_BUTTON_CLICK',
  ACCOUNT_FINANCIAL_HEALTH_MODAL_SHOWN: 'ACCOUNT_FINANCIAL_HEALTH_MODAL_SHOWN',
  ACCOUNT_FINANCIAL_HEALTH_CONFIRM_BUTTON_CLICK:
    'ACCOUNT_FINANCIAL_HEALTH_CONFIRM_BUTTON_CLICK',
  ACCOUNT_FINANCIAL_HEALTH_DISMISS_BUTTON_CLICK:
    'ACCOUNT_FINANCIAL_HEALTH_DISMISS_BUTTON_CLICK',
  ACCOUNT_DIVISION_SUCCESS_MODAL_SHOWN: 'ACCOUNT_DIVISION_SUCCESS_MODAL_SHOWN',
  ACCOUNT_DIVISION_REPAY_FIRST_BUTTON_CLICK:
    'ACCOUNT_DIVISION_REPAY_FIRST_BUTTON_CLICK',
  ACCOUNT_DIVISION_CLOSE_BUTTON_CLICK: 'ACCOUNT_DIVISION_CLOSE_BUTTON_CLICK',
  ACCOUNT_DIVISION_CONFIRMED: 'ACCOUNT_DIVISION_CONFIRMED',
  ACCOUNT_DIVISION_API_ERROR: 'ACCOUNT_DIVISION_API_ERROR',
  // Account — early repayment
  ACCOUNT_REPAY_EARLIER_MODAL_SHOWN: 'ACCOUNT_REPAY_EARLIER_MODAL_SHOWN',
  ACCOUNT_REPAY_EARLIER_SLIDER_CHANGED: 'ACCOUNT_REPAY_EARLIER_SLIDER_CHANGED',
  ACCOUNT_REPAY_EARLIER_CONTINUE_BUTTON_CLICK:
    'ACCOUNT_REPAY_EARLIER_CONTINUE_BUTTON_CLICK',
  ACCOUNT_REPAY_PAYMENT_SCREEN_VIEW: 'ACCOUNT_REPAY_PAYMENT_SCREEN_VIEW',
  ACCOUNT_REPAY_PAYMENT_METHOD_SELECTED:
    'ACCOUNT_REPAY_PAYMENT_METHOD_SELECTED',
  ACCOUNT_REPAY_PAYMENT_CONFIRMED: 'ACCOUNT_REPAY_PAYMENT_CONFIRMED',
  ACCOUNT_REPAY_PAYMENT_ERROR_SHOWN: 'ACCOUNT_REPAY_PAYMENT_ERROR_SHOWN',
  ACCOUNT_REPAY_PAYMENT_ERROR: 'ACCOUNT_REPAY_PAYMENT_ERROR',
  // Flow
  REGISTRATION_CONSENTS_SCREEN_VIEW: 'REGISTRATION_CONSENTS_SCREEN_VIEW',
  REGISTRATION_REJECTION_SCREEN_VIEW: 'REGISTRATION_REJECTION_SCREEN_VIEW',
  REGISTRATION_ERROR_SCREEN_VIEW: 'REGISTRATION_ERROR_SCREEN_VIEW',
  REGISTRATION_ERROR_DIALOG_VIEW: 'REGISTRATION_ERROR_DIALOG_VIEW',
  PHONE_NUMBER_INPUT_SCREEN_VIEW: 'PHONE_NUMBER_INPUT_SCREEN_VIEW',
  NAME_INPUT_SCREEN_VIEW: 'NAME_INPUT_SCREEN_VIEW',
  ADDRESS_INPUT_SCREEN_VIEW: 'ADDRESS_INPUT_SCREEN_VIEW',
  VERIFICATION_SPLASH_SCREEN_VIEW: 'VERIFICATION_SPLASH_SCREEN_VIEW',
  MANUAL_VERIFICATION_POP_UP_SCREEN_VIEW:
    'MANUAL_VERIFICATION_POP_UP_SCREEN_VIEW',
  INCOME_VERIFICATION_SPLASH_SCREEN_VIEW:
    'INCOME_VERIFICATION_SPLASH_SCREEN_VIEW',
  LIMIT_CONFIRMATION_SCREEN_VIEW: 'LIMIT_CONFIRMATION_SCREEN_VIEW',
  SUCCESS_FINAL_SCREEN_SCREEN_VIEW: 'SUCCESS_FINAL_SCREEN_SCREEN_VIEW',
  SPLASH_SCREEN_CZ_SCREEN_VIEW: 'SPLASH_SCREEN_CZ_SCREEN_VIEW',
  SPLASH_SCREEN_PL_SCREEN_VIEW: 'SPLASH_SCREEN_PL_SCREEN_VIEW',
  EMAIL_INPUT_SCREEN_VIEW: 'EMAIL_INPUT_SCREEN_VIEW',
  ACCOUNT_EXISTS_SCREEN_VIEW: 'ACCOUNT_EXISTS_SCREEN_VIEW',
  EMAIL_OTP_SCREEN_VIEW: 'EMAIL_OTP_SCREEN_VIEW',
  PHONE_CONFIRMATION_SCREEN_VIEW: 'PHONE_CONFIRMATION_SCREEN_VIEW',
  SET_PASSWORD_SCREEN_VIEW: 'SET_PASSWORD_SCREEN_VIEW',
  COUNTRY_OF_BIRTH_SCREEN_VIEW: 'COUNTRY_OF_BIRTH_SCREEN_VIEW',
  ID_NUMBER_INPUT_SCREEN_VIEW: 'ID_NUMBER_INPUT_SCREEN_VIEW',
  EDUCATION_LEVEL_SCREEN_VIEW: 'EDUCATION_LEVEL_SCREEN_VIEW',
  MARITAL_STATUS_SCREEN_VIEW: 'MARITAL_STATUS_SCREEN_VIEW',
  NUMBER_OF_KIDS_SCREEN_VIEW: 'NUMBER_OF_KIDS_SCREEN_VIEW',
  SOURCE_OF_INCOME_SCREEN_VIEW: 'SOURCE_OF_INCOME_SCREEN_VIEW',
  AREA_OF_WORK_CZ_SCREEN_VIEW: 'AREA_OF_WORK_CZ_SCREEN_VIEW',
  NET_INCOME_SCREEN_VIEW: 'NET_INCOME_SCREEN_VIEW',
  LOAN_REPAYMENTS_SCREEN_VIEW: 'LOAN_REPAYMENTS_SCREEN_VIEW',
  EXPENSES_EXCLUDING_LOAN_REPAYMENTS_SCREEN_VIEW:
    'EXPENSES_EXCLUDING_LOAN_REPAYMENTS_SCREEN_VIEW',
  INCOME_VERIFICATION_SUCCESS_SCREEN_SCREEN_VIEW:
    'INCOME_VERIFICATION_SUCCESS_SCREEN_SCREEN_VIEW',
  INCOME_VERIFICATION_TOO_LOW_ERROR_SCREEN_VIEW:
    'INCOME_VERIFICATION_TOO_LOW_ERROR_SCREEN_VIEW',
  INCOME_VERIFICATION_NO_INCOME_ERROR_SCREEN_VIEW:
    'INCOME_VERIFICATION_NO_INCOME_ERROR_SCREEN_VIEW',
  INCOME_VERIFICATION_CANT_VERIFY_ERROR_SCREEN_VIEW:
    'INCOME_VERIFICATION_CANT_VERIFY_ERROR_SCREEN_VIEW',
  INCOME_VERIFICATION_OTHER_ERROR_SCREEN_VIEW:
    'INCOME_VERIFICATION_OTHER_ERROR_SCREEN_VIEW',
  INSTALLMENTS_CONSENTS_SCREEN_VIEW: 'INSTALLMENTS_CONSENTS_SCREEN_VIEW',
  ACCOUNT_CREATION_LOADING_SPINNER_SCREEN_VIEW:
    'ACCOUNT_CREATION_LOADING_SPINNER_SCREEN_VIEW',
  APPROVAL_WAITING_MESSAGE_SCREEN_VIEW: 'APPROVAL_WAITING_MESSAGE_SCREEN_VIEW',
  PROCESSING_MESSAGE_SCREEN_VIEW: 'PROCESSING_MESSAGE_SCREEN_VIEW',
  INCOME_VERIFICATION_EXIT_SCREEN_VIEW: 'INCOME_VERIFICATION_EXIT_SCREEN_VIEW',
  KONTOMATIK_ADD_ACCOUNT_SCREEN_VIEW: 'KONTOMATIK_ADD_ACCOUNT_SCREEN_VIEW',
  SET_APP_CODE_SCREEN_VIEW: 'SET_APP_CODE_SCREEN_VIEW',
  VERIFF_SCREEN_VIEW: 'VERIFF_SCREEN_VIEW',
  CROSS_CHECK_SCREEN_VIEW: 'CROSS_CHECK_SCREEN_VIEW',
  EMAIL_INPUT_LOG_IN_BUTTON_CLICK: 'EMAIL_INPUT_LOG_IN_BUTTON_CLICK',
  EMAIL_INPUT_CONTINUE_BUTTON_CLICK: 'EMAIL_INPUT_CONTINUE_BUTTON_CLICK',
  ACCOUNT_EXISTS_FORGOT_YOUR_PASSWORD_LINK_CLICK:
    'ACCOUNT_EXISTS_FORGOT_YOUR_PASSWORD_LINK_CLICK',
  EMAIL_OTP_CONTINUE_BUTTON_CLICK: 'EMAIL_OTP_CONTINUE_BUTTON_CLICK',
  EMAIL_OTP_ERROR_BANNER_SHOWN: 'EMAIL_OTP_ERROR_BANNER_SHOWN',
  EMAIL_OTP_RESEND_EMAIL_BUTTON_CLICK: 'EMAIL_OTP_RESEND_EMAIL_BUTTON_CLICK',
  SPLASH_SCREEN_CZ_BANK_ID_BUTTON_BUTTON_CLICK:
    'SPLASH_SCREEN_CZ_BANK_ID_BUTTON_BUTTON_CLICK',
  SPLASH_SCREEN_CZ_MANUAL_REGISTRATION_BUTTON_CLICK:
    'SPLASH_SCREEN_CZ_MANUAL_REGISTRATION_BUTTON_CLICK',
  SPLASH_SCREEN_CZ_PRECONTRACTUAL_INFORMATION_LINK_CLICK:
    'SPLASH_SCREEN_CZ_PRECONTRACTUAL_INFORMATION_LINK_CLICK',
  SPLASH_SCREEN_CZ_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK:
    'SPLASH_SCREEN_CZ_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK',
  SPLASH_SCREEN_PL_MANUAL_REGISTRATION_BUTTON_CLICK:
    'SPLASH_SCREEN_PL_MANUAL_REGISTRATION_BUTTON_CLICK',
  SPLASH_SCREEN_PL_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK:
    'SPLASH_SCREEN_PL_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK',
  PROMO_CODE_MODAL_SHOWN: 'PROMO_CODE_MODAL_SHOWN',
  PROMO_CODE_X_BUTTON_BUTTON_CLICK: 'PROMO_CODE_X_BUTTON_BUTTON_CLICK',
  PROMO_CODE_CONTINUE_BUTTON_CLICK: 'PROMO_CODE_CONTINUE_BUTTON_CLICK',
  PROMO_CODE_ERROR_BANNER_SHOWN: 'PROMO_CODE_ERROR_BANNER_SHOWN',
  BANKID_TRY_AGAIN_TRY_AGAIN_BUTTON_BUTTON_CLICK:
    'BANKID_TRY_AGAIN_TRY_AGAIN_BUTTON_BUTTON_CLICK',
  BANKID_TRY_AGAIN_MANUAL_INPUT_BUTTON_BUTTON_CLICK:
    'BANKID_TRY_AGAIN_MANUAL_INPUT_BUTTON_BUTTON_CLICK',
  MANUAL_VERIFICATION_POP_UP_CONTINUE_MANUALLY_BUTTON_CLICK:
    'MANUAL_VERIFICATION_POP_UP_CONTINUE_MANUALLY_BUTTON_CLICK',
  MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_BANK_ID_BUTTON_CLICK:
    'MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_BANK_ID_BUTTON_CLICK',
  MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_MOBYWATEL_BUTTON_CLICK:
    'MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_MOBYWATEL_BUTTON_CLICK',
  SUCCESS_BANKID_CONTINUE_BUTTON_CLICK: 'SUCCESS_BANKID_CONTINUE_BUTTON_CLICK',
  SPLASH_SCREEN_PL_MOBYWATEL_BUTTON_CLICK:
    'SPLASH_SCREEN_PL_MOBYWATEL_BUTTON_CLICK',
  MOBYWATEL_TRY_AGAIN_BUTTON_CLICK: 'MOBYWATEL_TRY_AGAIN_BUTTON_CLICK',
  MOBYWATEL_MANUAL_INPUT_BUTTON_CLICK: 'MOBYWATEL_MANUAL_INPUT_BUTTON_CLICK',
  SUCCESS_MOBYWATEL_CONTINUE_BUTTON_CLICK:
    'SUCCESS_MOBYWATEL_CONTINUE_BUTTON_CLICK',
  REGISTRATION_CONSENTS_CONTINUE_BUTTON_CLICK:
    'REGISTRATION_CONSENTS_CONTINUE_BUTTON_CLICK',
  REGISTRATION_CONSENTS_CHECKBOX_DROPDOWN_SELECTED:
    'REGISTRATION_CONSENTS_CHECKBOX_DROPDOWN_SELECTED',
  REGISTRATION_CONSENTS_USER_CLICKS_A_LINK_TO_ANY_CONSENT_DOCUMENT_LINK_CLICK:
    'REGISTRATION_CONSENTS_USER_CLICKS_A_LINK_TO_ANY_CONSENT_DOCUMENT_LINK_CLICK',
  PEP_CONFIRMATION_MODAL_SHOWN: 'PEP_CONFIRMATION_MODAL_SHOWN',
  PEP_CONFIRMATION_MULTIPLE_CHOICE_DROPDOWN_SELECTED:
    'PEP_CONFIRMATION_MULTIPLE_CHOICE_DROPDOWN_SELECTED',
  PHONE_NUMBER_INPUT_CONTINUE_BUTTON_CLICK:
    'PHONE_NUMBER_INPUT_CONTINUE_BUTTON_CLICK',
  PHONE_CONFIRMATION_CONFIRM_CODE_BUTTON_CLICK:
    'PHONE_CONFIRMATION_CONFIRM_CODE_BUTTON_CLICK',
  PHONE_CONFIRMATION_RESEND_CODE_BUTTON_CLICK:
    'PHONE_CONFIRMATION_RESEND_CODE_BUTTON_CLICK',
  PHONE_CONFIRMATION_ERROR_BANNER_SHOWN:
    'PHONE_CONFIRMATION_ERROR_BANNER_SHOWN',
  SET_PASSWORD_SET_PASSWORD_BUTTON_CLICK:
    'SET_PASSWORD_SET_PASSWORD_BUTTON_CLICK',
  NAME_INPUT_CONTINUE_BUTTON_CLICK: 'NAME_INPUT_CONTINUE_BUTTON_CLICK',
  COUNTRY_OF_BIRTH_COUNTRY_DROPDOWN_DROPDOWN_SELECTED:
    'COUNTRY_OF_BIRTH_COUNTRY_DROPDOWN_DROPDOWN_SELECTED',
  COUNTRY_OF_BIRTH_SUBMIT_BUTTON_CLICK: 'COUNTRY_OF_BIRTH_SUBMIT_BUTTON_CLICK',
  ADDRESS_INPUT_CONTINUE_BUTTON_CLICK: 'ADDRESS_INPUT_CONTINUE_BUTTON_CLICK',
  ADDRESS_INPUT_ERROR_BANNER_SHOWN: 'ADDRESS_INPUT_ERROR_BANNER_SHOWN',
  ID_NUMBER_INPUT_CONTINUE_BUTTON_CLICK:
    'ID_NUMBER_INPUT_CONTINUE_BUTTON_CLICK',
  ID_NUMBER_INPUT_ERROR_BANNER_SHOWN: 'ID_NUMBER_INPUT_ERROR_BANNER_SHOWN',
  EDUCATION_LEVEL_EDUCATION_DROPDOWN_DROPDOWN_SELECTED:
    'EDUCATION_LEVEL_EDUCATION_DROPDOWN_DROPDOWN_SELECTED',
  MARITAL_STATUS_MARITAL_STATUS_DROPDOWN_DROPDOWN_SELECTED:
    'MARITAL_STATUS_MARITAL_STATUS_DROPDOWN_DROPDOWN_SELECTED',
  NUMBER_OF_KIDS_KIDS_COUNT_SELECTOR_DROPDOWN_SELECTED:
    'NUMBER_OF_KIDS_KIDS_COUNT_SELECTOR_DROPDOWN_SELECTED',
  SOURCE_OF_INCOME_CONTINUE_BUTTON_CLICK:
    'SOURCE_OF_INCOME_CONTINUE_BUTTON_CLICK',
  AREA_OF_WORK_CZ_AREA_OF_WORK_SELECTOR_DROPDOWN_SELECTED:
    'AREA_OF_WORK_CZ_AREA_OF_WORK_SELECTOR_DROPDOWN_SELECTED',
  HOUSING_TYPE_CZ_HOUSING_TYPE_SELECTOR_DROPDOWN_SELECTED:
    'HOUSING_TYPE_CZ_HOUSING_TYPE_SELECTOR_DROPDOWN_SELECTED',
  NET_INCOME_CONTINUE_BUTTON_CLICK: 'NET_INCOME_CONTINUE_BUTTON_CLICK',
  LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK:
    'LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK',
  EXPENSES_EXCLUDING_LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK:
    'EXPENSES_EXCLUDING_LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK',
  CROSS_CHECK_USER_GO_BACK_BUTTON_CLICK:
    'CROSS_CHECK_USER_GO_BACK_BUTTON_CLICK',
  CROSS_CHECK_USER_CONTINUE_BUTTON_CLICK:
    'CROSS_CHECK_USER_CONTINUE_BUTTON_CLICK',
  VERIFICATION_SPLASH_CONTINUE_BUTTON_CLICK:
    'VERIFICATION_SPLASH_CONTINUE_BUTTON_CLICK',
  VERIFF_START_VERIFICATION_BUTTON_CLICK:
    'VERIFF_START_VERIFICATION_BUTTON_CLICK',
  INCOME_VERIFICATION_EXIT_BACK_TO_VERIFICATION_BUTTON_CLICK:
    'INCOME_VERIFICATION_EXIT_BACK_TO_VERIFICATION_BUTTON_CLICK',
  INCOME_VERIFICATION_EXIT_SKIP_INCOME_VERIFICATION_BUTTON_CLICK:
    'INCOME_VERIFICATION_EXIT_SKIP_INCOME_VERIFICATION_BUTTON_CLICK',
  INCOME_VERIFICATION_SUCCESS_SCREEN_CONTINUE_BUTTON_CLICK:
    'INCOME_VERIFICATION_SUCCESS_SCREEN_CONTINUE_BUTTON_CLICK',
  INCOME_VERIFICATION_TOO_LOW_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK:
    'INCOME_VERIFICATION_TOO_LOW_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK',
  INCOME_VERIFICATION_TOO_LOW_ERROR_CONTINUE_WITH_REGISTRATION_BUTTON_CLICK:
    'INCOME_VERIFICATION_TOO_LOW_ERROR_CONTINUE_WITH_REGISTRATION_BUTTON_CLICK',
  INCOME_VERIFICATION_NO_INCOME_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK:
    'INCOME_VERIFICATION_NO_INCOME_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK',
  INCOME_VERIFICATION_CANT_VERIFY_ERROR_TRY_AGAIN_BUTTON_CLICK:
    'INCOME_VERIFICATION_CANT_VERIFY_ERROR_TRY_AGAIN_BUTTON_CLICK',
  INCOME_VERIFICATION_OTHER_ERROR_TRY_AGAIN_BUTTON_CLICK:
    'INCOME_VERIFICATION_OTHER_ERROR_TRY_AGAIN_BUTTON_CLICK',
  INCOME_VERIFICATION_OTHER_ERROR_CLOSE_BUTTON_CLICK:
    'INCOME_VERIFICATION_OTHER_ERROR_CLOSE_BUTTON_CLICK',
  LIMIT_CONFIRMATION_CONFIRM_LIMIT_BUTTON_CLICK:
    'LIMIT_CONFIRMATION_CONFIRM_LIMIT_BUTTON_CLICK',
  LIMIT_CONFIRMATION_CLOSE_BUTTON_CLICK:
    'LIMIT_CONFIRMATION_CLOSE_BUTTON_CLICK',
  INSTALLMENTS_CONSENTS_CONTINUE_BUTTON_CLICK:
    'INSTALLMENTS_CONSENTS_CONTINUE_BUTTON_CLICK',
  INSTALLMENTS_CONSENTS_CLOSE_BUTTON_CLICK:
    'INSTALLMENTS_CONSENTS_CLOSE_BUTTON_CLICK',
  EXIT_SCREEN_VIEW: 'EXIT_SCREEN_VIEW',
  EXIT_CONTINUE_BUTTON_CLICK: 'EXIT_CONTINUE_BUTTON_CLICK',
  EXIT_LEAVE_BUTTON_CLICK: 'EXIT_LEAVE_BUTTON_CLICK',
  INSTALLMENTS_CONSENTS_OPENED_DOCUMENTS_BUTTON_CLICK:
    'INSTALLMENTS_CONSENTS_OPENED_DOCUMENTS_BUTTON_CLICK',
  CONTRACT_SIGNATURE_OTP_CONTINUE_BUTTON_CLICK:
    'CONTRACT_SIGNATURE_OTP_CONTINUE_BUTTON_CLICK',
  CONTRACT_SIGNATURE_OTP_RESEND_CODE_BUTTON_CLICK:
    'CONTRACT_SIGNATURE_OTP_RESEND_CODE_BUTTON_CLICK',
  CONTRACT_SIGNATURE_OTP_ERROR_BANNER_SHOWN:
    'CONTRACT_SIGNATURE_OTP_ERROR_BANNER_SHOWN',
  SET_APP_CODE_CONFIRM_CODE_BUTTON_CLICK:
    'SET_APP_CODE_CONFIRM_CODE_BUTTON_CLICK',
  CONFIRM_APP_CODE_CONFIRM_CODE_BUTTON_CLICK:
    'CONFIRM_APP_CODE_CONFIRM_CODE_BUTTON_CLICK',
  TRIAL_PERIOD_START_TRIAL_BUTTON_CLICK:
    'TRIAL_PERIOD_START_TRIAL_BUTTON_CLICK',
  TRIAL_PERIOD_NOT_INTERESTED_BUTTON_CLICK:
    'TRIAL_PERIOD_NOT_INTERESTED_BUTTON_CLICK',
  SUCCESS_FINAL_SCREEN_GO_TO_OVERVIEW_BUTTON_CLICK:
    'SUCCESS_FINAL_SCREEN_GO_TO_OVERVIEW_BUTTON_CLICK',
  TRIAL_PROMO_SCREEN_VIEW: 'TRIAL_PROMO_SCREEN_VIEW',
  TRIAL_PROMO_CONTINUE_WITH_PLAN_BUTTON_CLICK:
    'TRIAL_PROMO_CONTINUE_WITH_PLAN_BUTTON_CLICK',
  TRIAL_PROMO_NOT_INTERESTED_BUTTON_CLICK:
    'TRIAL_PROMO_NOT_INTERESTED_BUTTON_CLICK',
  TRIAL_PROMO_PLAN_ASSIGNMENT_SUCCESS: 'TRIAL_PROMO_PLAN_ASSIGNMENT_SUCCESS',
  TRIAL_PROMO_PLAN_ASSIGNMENT_ERROR: 'TRIAL_PROMO_PLAN_ASSIGNMENT_ERROR',
  // Installment creation
  INSTALLMENT_CREATION_SCREEN_VIEW: 'INSTALLMENT_CREATION_SCREEN_VIEW',
  INSTALLMENT_CREATION_SLIDER_DROPDOWN_SELECTED:
    'INSTALLMENT_CREATION_SLIDER_DROPDOWN_SELECTED',
  INSTALLMENT_CREATION_MANUAL_INPUT_COMPLETE:
    'INSTALLMENT_CREATION_MANUAL_INPUT_COMPLETE',
  INSTALLMENT_CREATION_CONFIRM_BUTTON_CLICK:
    'INSTALLMENT_CREATION_CONFIRM_BUTTON_CLICK',
  INSTALLMENT_CREATION_API_RESPONSE: 'INSTALLMENT_CREATION_API_RESPONSE',
  INSTALLMENT_CREATION_ERROR_ERROR: 'INSTALLMENT_CREATION_ERROR_ERROR',
  INSTALLMENT_CREATION_CLOSE_ABANDONED: 'INSTALLMENT_CREATION_CLOSE_ABANDONED',
  // Contract withdrawal
  SETTINGS_WITHDRAW_FROM_CONTRACT__BUTTON_CLICK:
    'SETTINGS_WITHDRAW_FROM_CONTRACT__BUTTON_CLICK',
  WITHDRAW_FROM_CONTRACT_SCREEN_VIEW: 'WITHDRAW_FROM_CONTRACT_SCREEN_VIEW',
  WITHDRAW_FROM_CONTRACT_CONTINUE_BUTTON_CLICK:
    'WITHDRAW_FROM_CONTRACT_CONTINUE_BUTTON_CLICK',
  WITHDRAW_FROM_CONTRACT_CANCEL_BUTTON_CLICK:
    'WITHDRAW_FROM_CONTRACT_CANCEL_BUTTON_CLICK',
  WITHDRAW_FROM_CONTRACT_ELIGIBILITY_EXPIRED_BANNER_SHOWN:
    'WITHDRAW_FROM_CONTRACT_ELIGIBILITY_EXPIRED_BANNER_SHOWN',
  CONFIRM_WITHDRAWAL_SCREEN_VIEW: 'CONFIRM_WITHDRAWAL_SCREEN_VIEW',
  CONFIRM_WITHDRAWAL_BANK_ACCOUNT_COPY_BUTTON_CLICK:
    'CONFIRM_WITHDRAWAL_BANK_ACCOUNT_COPY_BUTTON_CLICK',
  CONFIRM_WITHDRAWAL_CANCEL_BUTTON_CLICK:
    'CONFIRM_WITHDRAWAL_CANCEL_BUTTON_CLICK',
  CONFIRM_WITHDRAWAL_CONFIRM_BUTTON_CLICK:
    'CONFIRM_WITHDRAWAL_CONFIRM_BUTTON_CLICK',
  CONFIRM_WITHDRAWAL_TERMINATION_API_RESPONSE:
    'CONFIRM_WITHDRAWAL_TERMINATION_API_RESPONSE',
  WITHDRAWAL_SUCCESS_SCREEN_VIEW: 'WITHDRAWAL_SUCCESS_SCREEN_VIEW',
  WITHDRAWAL_PARTIAL_FAILURE_SCREEN_VIEW:
    'WITHDRAWAL_PARTIAL_FAILURE_SCREEN_VIEW',
  WITHDRAWAL_FULL_FAILURE_SCREEN_VIEW: 'WITHDRAWAL_FULL_FAILURE_SCREEN_VIEW',
  WITHDRAWAL_PARTIAL_FAILURE_RETRY_BUTTON_CLICK:
    'WITHDRAWAL_PARTIAL_FAILURE_RETRY_BUTTON_CLICK',
  WITHDRAWAL_FULL_FAILURE_RETRY_BUTTON_CLICK:
    'WITHDRAWAL_FULL_FAILURE_RETRY_BUTTON_CLICK',
  // Shared
  SEARCH: 'search',
  EXPERIMENT_IMPRESSION: 'experiment_impression',
  SET_USER: 'setUser',
  SET_USER_SITE: 'setUserSite',
  GTM_DATA_CHANGE: 'GTMDataChange',
} as const

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]

export type AnalyticEvent = {
  name: AnalyticsEventName
  parameters: Record<string, unknown> | null
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnalyticEventFunction = (...args: any[]) => AnalyticEvent

export const events = {
  [ANALYTICS_EVENTS.FORM_CONTINUE]: (params: {
    currentStep: string
    service: string
    valid?: string
    telcoConsent?: string
  }) => {
    const { currentStep, service, valid, telcoConsent } = params

    return {
      name: ANALYTICS_EVENTS.FORM_CONTINUE,
      parameters: {
        currentStep,
        service,
        ...(valid === undefined ? { valid } : {}),
        ...(telcoConsent === undefined ? { telcoConsent } : {}),
      },
    }
  },
  [ANALYTICS_EVENTS.LOGOUT]: {
    name: ANALYTICS_EVENTS.LOGOUT,
    parameters: null,
  },
  [ANALYTICS_EVENTS.OPEN_SUPPORT_CHAT]: {
    name: ANALYTICS_EVENTS.OPEN_SUPPORT_CHAT,
    parameters: null,
  },
  [ANALYTICS_EVENTS.REGISTRATION_DROP]: {
    name: ANALYTICS_EVENTS.REGISTRATION_DROP,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PAYMENT_ACTIONS]: (parameters: {
    productAction: string
  }) => ({
    name: ANALYTICS_EVENTS.PAYMENT_ACTIONS,
    parameters,
  }),
  [ANALYTICS_EVENTS.MERCHANT_BENEFIT_MODAL_OPEN]: (params: {
    name: string
    merchant: string
  }) => ({
    name: ANALYTICS_EVENTS.MERCHANT_BENEFIT_MODAL_OPEN,
    parameters: { name: params.name, merchant: params.merchant },
  }),
  [ANALYTICS_EVENTS.MERCHANT_BENEFIT_DEAL_CLICK]: (params: {
    name: string
    merchant: string
  }) => ({
    name: ANALYTICS_EVENTS.MERCHANT_BENEFIT_DEAL_CLICK,
    parameters: { name: params.name, merchant: params.merchant },
  }),

  [ANALYTICS_EVENTS.SEARCH]: (params: { searchTerm: string }) => ({
    name: ANALYTICS_EVENTS.SEARCH,
    parameters: { search_term: params.searchTerm },
  }),
  [ANALYTICS_EVENTS.EXPERIMENT_IMPRESSION]: (params: {
    experimentId: string
    variant: string
  }) => ({
    name: ANALYTICS_EVENTS.EXPERIMENT_IMPRESSION,
    parameters: {
      experimentId: params.experimentId,
      variant: params.variant,
    },
  }),
  [ANALYTICS_EVENTS.SET_USER]: (params: { userId: string }) => ({
    name: ANALYTICS_EVENTS.SET_USER,
    parameters: { userId: params.userId },
  }),
  [ANALYTICS_EVENTS.SET_USER_SITE]: (params: { site: GLOBALS.Region }) => ({
    name: ANALYTICS_EVENTS.SET_USER_SITE,
    parameters: { site: params.site },
  }),
  [ANALYTICS_EVENTS.GTM_DATA_CHANGE]: {
    name: ANALYTICS_EVENTS.GTM_DATA_CHANGE,
    parameters: null,
  },
  [ANALYTICS_EVENTS.REGISTRATION_CONSENTS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.REGISTRATION_CONSENTS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.REGISTRATION_REJECTION_SCREEN_VIEW]: (params: {
    rejection_content: string
  }) => ({
    name: ANALYTICS_EVENTS.REGISTRATION_REJECTION_SCREEN_VIEW,
    parameters: {
      rejection_content: params.rejection_content,
    },
  }),
  [ANALYTICS_EVENTS.REGISTRATION_ERROR_SCREEN_VIEW]: (params: {
    error_message: string
  }) => ({
    name: ANALYTICS_EVENTS.REGISTRATION_ERROR_SCREEN_VIEW,
    parameters: {
      error_message: params.error_message,
    },
  }),
  [ANALYTICS_EVENTS.REGISTRATION_ERROR_DIALOG_VIEW]: (params: {
    error_message: string
    step?: string
  }) => ({
    name: ANALYTICS_EVENTS.REGISTRATION_ERROR_DIALOG_VIEW,
    parameters: {
      error_message: params.error_message,
      ...(params.step != null && { step: params.step }),
    },
  }),
  [ANALYTICS_EVENTS.PHONE_NUMBER_INPUT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PHONE_NUMBER_INPUT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.NAME_INPUT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.NAME_INPUT_SCREEN_VIEW,
    parameters: null,
  }),

  [ANALYTICS_EVENTS.ADDRESS_INPUT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.ADDRESS_INPUT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.VERIFICATION_SPLASH_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.VERIFICATION_SPLASH_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_SPLASH_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_SPLASH_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.LIMIT_CONFIRMATION_SCREEN_VIEW]: (params: {
    revLimit: number
    instLimit: number
  }) => ({
    name: ANALYTICS_EVENTS.LIMIT_CONFIRMATION_SCREEN_VIEW,
    parameters: { REV_LIMIT: params.revLimit, INST_LIMIT: params.instLimit },
  }),
  [ANALYTICS_EVENTS.SUCCESS_FINAL_SCREEN_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.SUCCESS_FINAL_SCREEN_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_SCREEN_VIEW]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_SCREEN_VIEW,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_PL_SCREEN_VIEW]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_PL_SCREEN_VIEW,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EMAIL_INPUT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.EMAIL_INPUT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_EXISTS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_EXISTS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.EMAIL_OTP_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.EMAIL_OTP_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PHONE_CONFIRMATION_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PHONE_CONFIRMATION_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.SET_PASSWORD_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.SET_PASSWORD_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ID_NUMBER_INPUT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.ID_NUMBER_INPUT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.EDUCATION_LEVEL_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.EDUCATION_LEVEL_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.MARITAL_STATUS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.MARITAL_STATUS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.NUMBER_OF_KIDS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.NUMBER_OF_KIDS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.SOURCE_OF_INCOME_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.SOURCE_OF_INCOME_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.AREA_OF_WORK_CZ_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.AREA_OF_WORK_CZ_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.NET_INCOME_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.NET_INCOME_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.LOAN_REPAYMENTS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.LOAN_REPAYMENTS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.EXPENSES_EXCLUDING_LOAN_REPAYMENTS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.EXPENSES_EXCLUDING_LOAN_REPAYMENTS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_SUCCESS_SCREEN_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_SUCCESS_SCREEN_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_NO_INCOME_ERROR_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_NO_INCOME_ERROR_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_CANT_VERIFY_ERROR_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_CANT_VERIFY_ERROR_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_CREATION_LOADING_SPINNER_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_CREATION_LOADING_SPINNER_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.APPROVAL_WAITING_MESSAGE_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.APPROVAL_WAITING_MESSAGE_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PROCESSING_MESSAGE_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PROCESSING_MESSAGE_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.KONTOMATIK_ADD_ACCOUNT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.KONTOMATIK_ADD_ACCOUNT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.SET_APP_CODE_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.SET_APP_CODE_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.VERIFF_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.VERIFF_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.CROSS_CHECK_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.CROSS_CHECK_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.EMAIL_INPUT_LOG_IN_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.EMAIL_INPUT_LOG_IN_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EMAIL_INPUT_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.EMAIL_INPUT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.ACCOUNT_EXISTS_FORGOT_YOUR_PASSWORD_LINK_CLICK]: {
    name: ANALYTICS_EVENTS.ACCOUNT_EXISTS_FORGOT_YOUR_PASSWORD_LINK_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EMAIL_OTP_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.EMAIL_OTP_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EMAIL_OTP_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.EMAIL_OTP_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EMAIL_OTP_RESEND_EMAIL_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.EMAIL_OTP_RESEND_EMAIL_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_BANK_ID_BUTTON_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_BANK_ID_BUTTON_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_MANUAL_REGISTRATION_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_MANUAL_REGISTRATION_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_PRECONTRACTUAL_INFORMATION_LINK_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_PRECONTRACTUAL_INFORMATION_LINK_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_CZ_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_PL_MANUAL_REGISTRATION_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_PL_MANUAL_REGISTRATION_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_PL_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_PL_I_HAVE_A_PROMO_CODE_LINK_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PROMO_CODE_MODAL_SHOWN]: {
    name: ANALYTICS_EVENTS.PROMO_CODE_MODAL_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PROMO_CODE_X_BUTTON_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.PROMO_CODE_X_BUTTON_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PROMO_CODE_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.PROMO_CODE_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PROMO_CODE_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.PROMO_CODE_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.BANKID_TRY_AGAIN_TRY_AGAIN_BUTTON_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.BANKID_TRY_AGAIN_TRY_AGAIN_BUTTON_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.BANKID_TRY_AGAIN_MANUAL_INPUT_BUTTON_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.BANKID_TRY_AGAIN_MANUAL_INPUT_BUTTON_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_MANUALLY_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_MANUALLY_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_BANK_ID_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_BANK_ID_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_MOBYWATEL_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.MANUAL_VERIFICATION_POP_UP_CONTINUE_WITH_MOBYWATEL_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.SUCCESS_BANKID_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SUCCESS_BANKID_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SPLASH_SCREEN_PL_MOBYWATEL_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SPLASH_SCREEN_PL_MOBYWATEL_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.MOBYWATEL_TRY_AGAIN_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.MOBYWATEL_TRY_AGAIN_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.MOBYWATEL_MANUAL_INPUT_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.MOBYWATEL_MANUAL_INPUT_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SUCCESS_MOBYWATEL_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SUCCESS_MOBYWATEL_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.REGISTRATION_CONSENTS_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.REGISTRATION_CONSENTS_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.REGISTRATION_CONSENTS_CHECKBOX_DROPDOWN_SELECTED]:
    (params: { consents: string }) => ({
      name: ANALYTICS_EVENTS.REGISTRATION_CONSENTS_CHECKBOX_DROPDOWN_SELECTED,
      parameters: { CONSENTS: params.consents },
    }),
  [ANALYTICS_EVENTS.REGISTRATION_CONSENTS_USER_CLICKS_A_LINK_TO_ANY_CONSENT_DOCUMENT_LINK_CLICK]:
    (params: { consentDocView: string }) => ({
      name: ANALYTICS_EVENTS.REGISTRATION_CONSENTS_USER_CLICKS_A_LINK_TO_ANY_CONSENT_DOCUMENT_LINK_CLICK,
      parameters: { CONSENTS_DOC_VIEW: params.consentDocView },
    }),
  [ANALYTICS_EVENTS.PEP_CONFIRMATION_MODAL_SHOWN]: {
    name: ANALYTICS_EVENTS.PEP_CONFIRMATION_MODAL_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PEP_CONFIRMATION_MULTIPLE_CHOICE_DROPDOWN_SELECTED]:
    (params: { pepSelect: string }) => ({
      name: ANALYTICS_EVENTS.PEP_CONFIRMATION_MULTIPLE_CHOICE_DROPDOWN_SELECTED,
      parameters: { PEP_SELECT: params.pepSelect },
    }),
  [ANALYTICS_EVENTS.PHONE_NUMBER_INPUT_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.PHONE_NUMBER_INPUT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PHONE_CONFIRMATION_CONFIRM_CODE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.PHONE_CONFIRMATION_CONFIRM_CODE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PHONE_CONFIRMATION_RESEND_CODE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.PHONE_CONFIRMATION_RESEND_CODE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.PHONE_CONFIRMATION_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.PHONE_CONFIRMATION_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SET_PASSWORD_SET_PASSWORD_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SET_PASSWORD_SET_PASSWORD_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.NAME_INPUT_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.NAME_INPUT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_COUNTRY_DROPDOWN_DROPDOWN_SELECTED]:
    (params: { countryOfBirth: string }) => ({
      name: ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_COUNTRY_DROPDOWN_DROPDOWN_SELECTED,
      parameters: { COUNTRY_OF_BIRTH: params.countryOfBirth },
    }),
  [ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_SUBMIT_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.COUNTRY_OF_BIRTH_SUBMIT_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.ADDRESS_INPUT_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.ADDRESS_INPUT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.ADDRESS_INPUT_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.ADDRESS_INPUT_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.ID_NUMBER_INPUT_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.ID_NUMBER_INPUT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.ID_NUMBER_INPUT_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.ID_NUMBER_INPUT_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EDUCATION_LEVEL_EDUCATION_DROPDOWN_DROPDOWN_SELECTED]:
    (params: { education: string }) => ({
      name: ANALYTICS_EVENTS.EDUCATION_LEVEL_EDUCATION_DROPDOWN_DROPDOWN_SELECTED,
      parameters: { EDUCATION: params.education },
    }),
  [ANALYTICS_EVENTS.MARITAL_STATUS_MARITAL_STATUS_DROPDOWN_DROPDOWN_SELECTED]:
    (params: { maritalStatus: string }) => ({
      name: ANALYTICS_EVENTS.MARITAL_STATUS_MARITAL_STATUS_DROPDOWN_DROPDOWN_SELECTED,
      parameters: { MARITAL_STATUS: params.maritalStatus },
    }),
  [ANALYTICS_EVENTS.NUMBER_OF_KIDS_KIDS_COUNT_SELECTOR_DROPDOWN_SELECTED]:
    (params: { kidsCount: string }) => ({
      name: ANALYTICS_EVENTS.NUMBER_OF_KIDS_KIDS_COUNT_SELECTOR_DROPDOWN_SELECTED,
      parameters: { KIDS_COUNT: params.kidsCount },
    }),
  [ANALYTICS_EVENTS.SOURCE_OF_INCOME_CONTINUE_BUTTON_CLICK]: (params: {
    sourceOfIncome: string
  }) => ({
    name: ANALYTICS_EVENTS.SOURCE_OF_INCOME_CONTINUE_BUTTON_CLICK,
    parameters: { SOURCE_OF_INCOME: params.sourceOfIncome },
  }),
  [ANALYTICS_EVENTS.AREA_OF_WORK_CZ_AREA_OF_WORK_SELECTOR_DROPDOWN_SELECTED]:
    (params: { areaOfWork: string }) => ({
      name: ANALYTICS_EVENTS.AREA_OF_WORK_CZ_AREA_OF_WORK_SELECTOR_DROPDOWN_SELECTED,
      parameters: { AREA_OF_WORK: params.areaOfWork },
    }),
  [ANALYTICS_EVENTS.HOUSING_TYPE_CZ_HOUSING_TYPE_SELECTOR_DROPDOWN_SELECTED]:
    (params: { housingType: string }) => ({
      name: ANALYTICS_EVENTS.HOUSING_TYPE_CZ_HOUSING_TYPE_SELECTOR_DROPDOWN_SELECTED,
      parameters: { HOUSING_TYPE: params.housingType },
    }),
  [ANALYTICS_EVENTS.NET_INCOME_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.NET_INCOME_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EXPENSES_EXCLUDING_LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.EXPENSES_EXCLUDING_LOAN_REPAYMENTS_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.CROSS_CHECK_USER_GO_BACK_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.CROSS_CHECK_USER_GO_BACK_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.CROSS_CHECK_USER_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.CROSS_CHECK_USER_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.VERIFICATION_SPLASH_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.VERIFICATION_SPLASH_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.VERIFF_START_VERIFICATION_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.VERIFF_START_VERIFICATION_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_BACK_TO_VERIFICATION_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_BACK_TO_VERIFICATION_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_SKIP_INCOME_VERIFICATION_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_EXIT_SKIP_INCOME_VERIFICATION_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_SUCCESS_SCREEN_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_SUCCESS_SCREEN_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_CONTINUE_WITH_REGISTRATION_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_TOO_LOW_ERROR_CONTINUE_WITH_REGISTRATION_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_NO_INCOME_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_NO_INCOME_ERROR_CONNECT_ANOTHER_ACCOUNT_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_CANT_VERIFY_ERROR_TRY_AGAIN_BUTTON_CLICK]:
    {
      name: ANALYTICS_EVENTS.INCOME_VERIFICATION_CANT_VERIFY_ERROR_TRY_AGAIN_BUTTON_CLICK,
      parameters: null,
    },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_TRY_AGAIN_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_TRY_AGAIN_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_CLOSE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.INCOME_VERIFICATION_OTHER_ERROR_CLOSE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.LIMIT_CONFIRMATION_CONFIRM_LIMIT_BUTTON_CLICK]: (params: {
    revLimit: number
    instLimit: number
  }) => ({
    name: ANALYTICS_EVENTS.LIMIT_CONFIRMATION_CONFIRM_LIMIT_BUTTON_CLICK,
    parameters: { REV_LIMIT: params.revLimit, INST_LIMIT: params.instLimit },
  }),
  [ANALYTICS_EVENTS.LIMIT_CONFIRMATION_CLOSE_BUTTON_CLICK]: (params: {
    revLimit: number
    instLimit: number
  }) => ({
    name: ANALYTICS_EVENTS.LIMIT_CONFIRMATION_CLOSE_BUTTON_CLICK,
    parameters: { REV_LIMIT: params.revLimit, INST_LIMIT: params.instLimit },
  }),
  [ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_CLOSE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_CLOSE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.EXIT_SCREEN_VIEW]: (params: { step: string }) => ({
    name: ANALYTICS_EVENTS.EXIT_SCREEN_VIEW,
    parameters: { STEP: params.step },
  }),
  [ANALYTICS_EVENTS.EXIT_CONTINUE_BUTTON_CLICK]: (params: {
    step: string
  }) => ({
    name: ANALYTICS_EVENTS.EXIT_CONTINUE_BUTTON_CLICK,
    parameters: { STEP: params.step },
  }),
  [ANALYTICS_EVENTS.EXIT_LEAVE_BUTTON_CLICK]: (params: { step: string }) => ({
    name: ANALYTICS_EVENTS.EXIT_LEAVE_BUTTON_CLICK,
    parameters: { STEP: params.step },
  }),
  [ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_OPENED_DOCUMENTS_BUTTON_CLICK]:
    (params: { contractRead: string }) => ({
      name: ANALYTICS_EVENTS.INSTALLMENTS_CONSENTS_OPENED_DOCUMENTS_BUTTON_CLICK,
      parameters: { CONTRACT_READ: params.contractRead },
    }),
  [ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_CONTINUE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_CONTINUE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_RESEND_CODE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_RESEND_CODE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_ERROR_BANNER_SHOWN]: {
    name: ANALYTICS_EVENTS.CONTRACT_SIGNATURE_OTP_ERROR_BANNER_SHOWN,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SET_APP_CODE_CONFIRM_CODE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SET_APP_CODE_CONFIRM_CODE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.CONFIRM_APP_CODE_CONFIRM_CODE_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.CONFIRM_APP_CODE_CONFIRM_CODE_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.TRIAL_PERIOD_START_TRIAL_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.TRIAL_PERIOD_START_TRIAL_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.TRIAL_PERIOD_NOT_INTERESTED_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.TRIAL_PERIOD_NOT_INTERESTED_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.SUCCESS_FINAL_SCREEN_GO_TO_OVERVIEW_BUTTON_CLICK]: {
    name: ANALYTICS_EVENTS.SUCCESS_FINAL_SCREEN_GO_TO_OVERVIEW_BUTTON_CLICK,
    parameters: null,
  },
  [ANALYTICS_EVENTS.TRIAL_PROMO_SCREEN_VIEW]: (params: {
    planType: string
  }) => ({
    name: ANALYTICS_EVENTS.TRIAL_PROMO_SCREEN_VIEW,
    parameters: { PLAN_TYPE: params.planType },
  }),
  [ANALYTICS_EVENTS.TRIAL_PROMO_CONTINUE_WITH_PLAN_BUTTON_CLICK]: (params: {
    planType: string
  }) => ({
    name: ANALYTICS_EVENTS.TRIAL_PROMO_CONTINUE_WITH_PLAN_BUTTON_CLICK,
    parameters: { PLAN_TYPE: params.planType },
  }),
  [ANALYTICS_EVENTS.TRIAL_PROMO_NOT_INTERESTED_BUTTON_CLICK]: (params: {
    planType: string
  }) => ({
    name: ANALYTICS_EVENTS.TRIAL_PROMO_NOT_INTERESTED_BUTTON_CLICK,
    parameters: { PLAN_TYPE: params.planType },
  }),
  [ANALYTICS_EVENTS.TRIAL_PROMO_PLAN_ASSIGNMENT_SUCCESS]: (params: {
    planType: string
  }) => ({
    name: ANALYTICS_EVENTS.TRIAL_PROMO_PLAN_ASSIGNMENT_SUCCESS,
    parameters: { PLAN_TYPE: params.planType },
  }),
  [ANALYTICS_EVENTS.TRIAL_PROMO_PLAN_ASSIGNMENT_ERROR]: (params: {
    planType: string
    errorCode: string
  }) => ({
    name: ANALYTICS_EVENTS.TRIAL_PROMO_PLAN_ASSIGNMENT_ERROR,
    parameters: { PLAN_TYPE: params.planType, ERROR_CODE: params.errorCode },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_SCREEN_VIEW]: (params: {
    invoiceType?: string
    invoiceAmount?: number
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_SCREEN_VIEW,
    parameters: {
      INVOICE_TYPE: params.invoiceType,
      INVOICE_AMOUNT: params.invoiceAmount,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_SLIDER_DROPDOWN_SELECTED]: (params: {
    tenor: number
    monthlyAmount?: number
    totalFee?: number
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_SLIDER_DROPDOWN_SELECTED,
    parameters: {
      TENOR: params.tenor,
      MONTHLY_AMOUNT: params.monthlyAmount,
      TOTAL_FEE: params.totalFee,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_MANUAL_INPUT_COMPLETE]: (params: {
    tenor: number
    valid: boolean
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_MANUAL_INPUT_COMPLETE,
    parameters: {
      TENOR: params.tenor,
      VALID: params.valid,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_CONFIRM_BUTTON_CLICK]: (params: {
    tenor: number
    invoiceType?: string
    totalFee?: number
    apr?: number
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_CONFIRM_BUTTON_CLICK,
    parameters: {
      TENOR: params.tenor,
      INVOICE_TYPE: params.invoiceType,
      TOTAL_FEE: params.totalFee,
      APR: params.apr,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_API_RESPONSE]: (params: {
    tenor: number
    invoiceType?: string
    scheduleId: string
    status: 'success'
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_API_RESPONSE,
    parameters: {
      TENOR: params.tenor,
      INVOICE_TYPE: params.invoiceType,
      SCHEDULE_ID: params.scheduleId,
      STATUS: params.status,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_ERROR_ERROR]: (params: {
    errorCode: string
    errorType: 'VALIDATION' | 'API_ERROR' | 'AMOUNT_TOO_LOW'
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_ERROR_ERROR,
    parameters: {
      ERROR_CODE: params.errorCode,
      ERROR_TYPE: params.errorType,
    },
  }),
  [ANALYTICS_EVENTS.INSTALLMENT_CREATION_CLOSE_ABANDONED]: (params: {
    tenor?: number
  }) => ({
    name: ANALYTICS_EVENTS.INSTALLMENT_CREATION_CLOSE_ABANDONED,
    parameters: {
      TENOR: params.tenor,
    },
  }),

  // PSP BNPL CZ checkout
  [ANALYTICS_EVENTS.PSP_CONTACT_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PSP_CONTACT_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_CONTACT_CONTINUE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_CONTACT_CONTINUE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_CONTACT_ERROR_BANNER_SHOWN]: (params: {
    message: string
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CONTACT_ERROR_BANNER_SHOWN,
    parameters: { MESSAGE: params.message },
  }),
  [ANALYTICS_EVENTS.PSP_PERSONAL_INFO_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PSP_PERSONAL_INFO_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_PERSONAL_INFO_CONTINUE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_PERSONAL_INFO_CONTINUE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_ADDRESS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PSP_ADDRESS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_ADDRESS_CONTINUE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_ADDRESS_CONTINUE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_BANK_ID_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_BANK_ID_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_ID_SCAN_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_VERIFICATION_CHOICE_ID_SCAN_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_BANK_ID_REDIRECT]: () => ({
    name: ANALYTICS_EVENTS.PSP_BANK_ID_REDIRECT,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_BANK_ID_CALLBACK]: (params: {
    status: 'success' | 'failure' | 'cancelled'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_BANK_ID_CALLBACK,
    parameters: { STATUS: params.status },
  }),
  [ANALYTICS_EVENTS.PSP_BANK_ID_ERROR_SCREEN_VIEW]: (params: {
    errorCode: string
  }) => ({
    name: ANALYTICS_EVENTS.PSP_BANK_ID_ERROR_SCREEN_VIEW,
    parameters: { ERROR_CODE: params.errorCode },
  }),
  [ANALYTICS_EVENTS.PSP_BANK_ID_ERROR_TRY_AGAIN_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_BANK_ID_ERROR_TRY_AGAIN_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_ID_SCAN_START]: () => ({
    name: ANALYTICS_EVENTS.PSP_ID_SCAN_START,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_ID_SCAN_COMPLETE]: (params: {
    status: 'success' | 'failure' | 'cancelled'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_ID_SCAN_COMPLETE,
    parameters: { STATUS: params.status },
  }),
  [ANALYTICS_EVENTS.PSP_CREDIT_CHECK_START]: () => ({
    name: ANALYTICS_EVENTS.PSP_CREDIT_CHECK_START,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_CREDIT_CHECK_COMPLETE]: (params: {
    result: 'approved' | 'rejected'
    rejectionReason?:
      | 'insolvency'
      | 'execution_active'
      | 'creditcheck_negative'
      | 'score_below_threshold'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CREDIT_CHECK_COMPLETE,
    parameters: {
      RESULT: params.result,
      ...(params.rejectionReason !== undefined && {
        REJECTION_REASON: params.rejectionReason,
      }),
    },
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_SCREEN_VIEW]: () => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_SCREEN_VIEW,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_DOCUMENT_CLICK]: (params: {
    documentType: string
  }) => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_DOCUMENT_CLICK,
    parameters: { DOCUMENT_TYPE: params.documentType },
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_CHECKBOX_CHECK]: (params: {
    checkboxId: string
    method: 'manual' | 'select_all'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_CHECKBOX_CHECK,
    parameters: { CHECKBOX_ID: params.checkboxId, METHOD: params.method },
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_SELECT_ALL_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_SELECT_ALL_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_AGREE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_AGREE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.PSP_LEGAL_DOCS_LOAD_ERROR]: (params: {
    documentType: string
    retryCount: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_LEGAL_DOCS_LOAD_ERROR,
    parameters: {
      DOCUMENT_TYPE: params.documentType,
      RETRY_COUNT: params.retryCount,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CONTRACT_CONCLUDED]: (params: { orderId: string }) => ({
    name: ANALYTICS_EVENTS.PSP_CONTRACT_CONCLUDED,
    parameters: { ORDER_ID: params.orderId },
  }),
  [ANALYTICS_EVENTS.PSP_SUCCESS_SCREEN_VIEW]: (params: {
    orderId: string
  }) => ({
    name: ANALYTICS_EVENTS.PSP_SUCCESS_SCREEN_VIEW,
    parameters: { ORDER_ID: params.orderId },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_ABANDONED]: (params: {
    lastStep:
      | 'contact'
      | 'personal_info'
      | 'address'
      | 'verification'
      | 'credit_check'
      | 'legal_docs'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_ABANDONED,
    parameters: { LAST_STEP: params.lastStep },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    amount: number
    currency: 'CZK' | 'PLN'
    discountApplied: boolean
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      AMOUNT: params.amount,
      CURRENCY: params.currency,
      DISCOUNT_APPLIED: params.discountApplied,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_LEARN_MORE_LINK_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_LEARN_MORE_LINK_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_CONTACT_US_LINK_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_CONTACT_US_LINK_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_PAY_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    amount: number
    currency: 'CZK' | 'PLN'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_PAY_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      AMOUNT: params.amount,
      CURRENCY: params.currency,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_BACK_TO_SHOP_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_WELCOME_BACK_TO_SHOP_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    amount: number
    payToday: number
    currency: 'CZK' | 'PLN'
    prefillComplete: boolean
    missingFields: Array<
      'name' | 'phone' | 'street' | 'building_number' | 'city' | 'postal_code'
    >
    discountApplied: boolean
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      AMOUNT: params.amount,
      PAY_TODAY: params.payToday,
      CURRENCY: params.currency,
      PREFILL_COMPLETE: params.prefillComplete,
      MISSING_FIELDS: params.missingFields,
      DISCOUNT_APPLIED: params.discountApplied,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_IDENTITY_EDIT_BUTTON_CLICK]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_IDENTITY_EDIT_BUTTON_CLICK,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONTACT_EDIT_BUTTON_CLICK]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONTACT_EDIT_BUTTON_CLICK,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_SAVE_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    field:
      | 'name'
      | 'email'
      | 'phone'
      | 'street'
      | 'building_number'
      | 'city'
      | 'postal_code'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_SAVE_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      FIELD: params.field,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_ERROR_BANNER_SHOWN]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    field:
      | 'name'
      | 'phone'
      | 'street'
      | 'building_number'
      | 'city'
      | 'postal_code'
    errorType: 'missing' | 'invalid_format' | 'validation_failed'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_ERROR_BANNER_SHOWN,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      FIELD: params.field,
      ERROR_TYPE: params.errorType,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONSENTS_EXPANDER_BUTTON_CLICK]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONSENTS_EXPANDER_BUTTON_CLICK,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONSENT_CHECK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    consentId: string
    checked: boolean
    method: 'master' | 'individual'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONSENT_CHECK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      CONSENT_ID: params.consentId,
      CHECKED: params.checked,
      METHOD: params.method,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONFIRM_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    oneTap: boolean
    amount: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_CONFIRM_PAY_CONFIRM_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      ONE_TAP: params.oneTap,
      AMOUNT: params.amount,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_APP_HANDOFF_OPEN_IN_APP_MODAL_SHOWN]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_APP_HANDOFF_OPEN_IN_APP_MODAL_SHOWN,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_APP_HANDOFF_RESULT_API_RESPONSE]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    result: 'opened' | 'stayed_in_browser'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_APP_HANDOFF_RESULT_API_RESPONSE,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      RESULT: params.result,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PAYMENT_PLAN_AMOUNT_INFO_BUTTON_CLICK]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
      rowCount: number
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_PAYMENT_PLAN_AMOUNT_INFO_BUTTON_CLICK,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
        ROW_COUNT: params.rowCount,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PAYMENT_PLAN_GOT_IT_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PAYMENT_PLAN_GOT_IT_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    step: number
    stepTotal: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      STEP: params.step,
      STEP_TOTAL: params.stepTotal,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_CONTINUE_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_CONTINUE_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_RESEND_CODE_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    attempt: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_RESEND_CODE_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      ATTEMPT: params.attempt,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_ERROR_BANNER_SHOWN]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    reason: 'wrong_code' | 'expired' | 'max_attempts'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PHONE_OTP_ERROR_BANNER_SHOWN,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      REASON: params.reason,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    step: number
    stepTotal: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      STEP: params.step,
      STEP_TOTAL: params.stepTotal,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_CONFIRM_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_CONFIRM_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_VALIDATION_ERROR_BANNER_SHOWN]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
      reason: 'length' | 'checksum'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_VALIDATION_ERROR_BANNER_SHOWN,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
        REASON: params.reason,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_VERIFICATION_API_RESPONSE]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    result: 'pass' | 'transient_failure' | 'definitive_failure'
    attempt: number
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_PESEL_VERIFICATION_API_RESPONSE,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      RESULT: params.result,
      ATTEMPT: params.attempt,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_SCORING_API_RESPONSE]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    result: 'approved' | 'rejected'
    rejectionReason: string | null
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_SCORING_API_RESPONSE,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      RESULT: params.result,
      REJECTION_REASON: params.rejectionReason,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    amount: number
    currency: 'CZK' | 'PLN'
    upsellShown: boolean
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      AMOUNT: params.amount,
      CURRENCY: params.currency,
      UPSELL_SHOWN: params.upsellShown,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_START_FREE_TRIAL_BUTTON_CLICK]:
    (params: {
      site: GLOBALS.Region
      product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
      accountTier: 'no_account' | 'basic' | 'premium'
      source: 'checkout_success_upsell'
    }) => ({
      name: ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_START_FREE_TRIAL_BUTTON_CLICK,
      parameters: {
        SITE: params.site,
        PRODUCT: params.product,
        ACCOUNT_TIER: params.accountTier,
        SOURCE: params.source,
      },
    }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_NOT_THIS_TIME_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_SUCCESS_NOT_THIS_TIME_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_REJECTION_SCREEN_VIEW]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    rejectedAtStep: 'pesel' | 'scoring' | 'verification'
    reason: string | null
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_REJECTION_SCREEN_VIEW,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      REJECTED_AT_STEP: params.rejectedAtStep,
      REASON: params.reason,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_FLOW_CLOSE_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    step:
      | 'welcome'
      | 'confirm_pay'
      | 'phone_otp'
      | 'pesel'
      | 'verification'
      | 'legal_docs'
      | 'sign'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_FLOW_CLOSE_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      STEP: params.step,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_FLOW_BACK_BUTTON_CLICK]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    step:
      | 'welcome'
      | 'confirm_pay'
      | 'phone_otp'
      | 'pesel'
      | 'verification'
      | 'legal_docs'
      | 'sign'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_FLOW_BACK_BUTTON_CLICK,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      STEP: params.step,
    },
  }),
  [ANALYTICS_EVENTS.PSP_CHECKOUT_SESSION_ABANDONED]: (params: {
    site: GLOBALS.Region
    product: 'bnpl' | 'paid_bnpl' | 'pay_in_3' | 'pay_in_n'
    accountTier: 'no_account' | 'basic' | 'premium'
    lastCompletedStep:
      | 'welcome'
      | 'confirm_pay'
      | 'phone_otp'
      | 'pesel'
      | 'verification'
      | 'legal_docs'
      | 'sign'
    exitMethod:
      | 'close_button'
      | 'back_to_shop'
      | 'browser_close'
      | 'navigate_away'
      | 'session_timeout'
  }) => ({
    name: ANALYTICS_EVENTS.PSP_CHECKOUT_SESSION_ABANDONED,
    parameters: {
      SITE: params.site,
      PRODUCT: params.product,
      ACCOUNT_TIER: params.accountTier,
      LAST_COMPLETED_STEP: params.lastCompletedStep,
      EXIT_METHOD: params.exitMethod,
    },
  }),

  // Account — invoice division
  [ANALYTICS_EVENTS.ACCOUNT_DIVIDE_LINK_SHOWN]: (params: {
    invoiceId: string
    amount: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVIDE_LINK_SHOWN,
    parameters: { INVOICE_ID: params.invoiceId, AMOUNT: params.amount },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVIDE_LINK_CLICK]: (params: {
    invoiceId: string
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVIDE_LINK_CLICK,
    parameters: { INVOICE_ID: params.invoiceId },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_INSTALLMENT_PREVIEW_MODAL_SHOWN]: (params: {
    totalFee: number
    apr: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_INSTALLMENT_PREVIEW_MODAL_SHOWN,
    parameters: { TOTAL_FEE: params.totalFee, APR: params.apr },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_INSTALLMENT_PREVIEW_CONTINUE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_INSTALLMENT_PREVIEW_CONTINUE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_MODAL_SHOWN]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_MODAL_SHOWN,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_CONFIRM_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_CONFIRM_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_DISMISS_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_FINANCIAL_HEALTH_DISMISS_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVISION_SUCCESS_MODAL_SHOWN]: (params: {
    invoiceId: string
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVISION_SUCCESS_MODAL_SHOWN,
    parameters: { INVOICE_ID: params.invoiceId },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVISION_REPAY_FIRST_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVISION_REPAY_FIRST_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVISION_CLOSE_BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVISION_CLOSE_BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVISION_CONFIRMED]: (params: {
    invoiceId: string
    installments: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVISION_CONFIRMED,
    parameters: {
      INVOICE_ID: params.invoiceId,
      INSTALLMENTS: params.installments,
    },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_DIVISION_API_ERROR]: (params: {
    errorCode: string
    invoiceId: string
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_DIVISION_API_ERROR,
    parameters: { ERROR_CODE: params.errorCode, INVOICE_ID: params.invoiceId },
  }),

  // Account — early repayment
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_MODAL_SHOWN]: (params: {
    maxAmount: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_MODAL_SHOWN,
    parameters: { MAX_AMOUNT: params.maxAmount },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_SLIDER_CHANGED]: (params: {
    sliderValue: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_SLIDER_CHANGED,
    parameters: { SLIDER_VALUE: params.sliderValue },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_CONTINUE_BUTTON_CLICK]: (params: {
    amount: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_EARLIER_CONTINUE_BUTTON_CLICK,
    parameters: { AMOUNT: params.amount },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_SCREEN_VIEW]: (params: {
    amount: number
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_SCREEN_VIEW,
    parameters: { AMOUNT: params.amount },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_METHOD_SELECTED]: (params: {
    method: RepayPaymentMethod
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_METHOD_SELECTED,
    parameters: { METHOD: params.method },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_CONFIRMED]: (params: {
    amount: number
    repayType: EarlyRepayType
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_CONFIRMED,
    parameters: { AMOUNT: params.amount, REPAY_TYPE: params.repayType },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_ERROR_SHOWN]: (params: {
    errorCode: string
    repayType: EarlyRepayType
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_ERROR_SHOWN,
    parameters: { ERROR_CODE: params.errorCode, REPAY_TYPE: params.repayType },
  }),
  [ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_ERROR]: (params: {
    errorCode: string
    repayType: EarlyRepayType
  }) => ({
    name: ANALYTICS_EVENTS.ACCOUNT_REPAY_PAYMENT_ERROR,
    parameters: { ERROR_CODE: params.errorCode, REPAY_TYPE: params.repayType },
  }),
  [ANALYTICS_EVENTS.SETTINGS_WITHDRAW_FROM_CONTRACT__BUTTON_CLICK]: () => ({
    name: ANALYTICS_EVENTS.SETTINGS_WITHDRAW_FROM_CONTRACT__BUTTON_CLICK,
    parameters: null,
  }),
  [ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_SCREEN_VIEW]: (params: {
    ELIGIBLE_COUNT: number
    INELIGIBLE_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_SCREEN_VIEW,
    parameters: {
      ELIGIBLE_COUNT: params.ELIGIBLE_COUNT,
      INELIGIBLE_COUNT: params.INELIGIBLE_COUNT,
    },
  }),
  [ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_CONTINUE_BUTTON_CLICK]: (params: {
    SELECTED_COUNT: number
    SELECTED_CONTRACT_NAMES: string[]
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_CONTINUE_BUTTON_CLICK,
    parameters: {
      SELECTED_COUNT: params.SELECTED_COUNT,
      SELECTED_CONTRACT_NAMES: params.SELECTED_CONTRACT_NAMES,
    },
  }),
  [ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_CANCEL_BUTTON_CLICK]: (params: {
    ELIGIBLE_COUNT: number
    SELECTED_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_CANCEL_BUTTON_CLICK,
    parameters: {
      ELIGIBLE_COUNT: params.ELIGIBLE_COUNT,
      SELECTED_COUNT: params.SELECTED_COUNT,
    },
  }),
  [ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_ELIGIBILITY_EXPIRED_BANNER_SHOWN]:
    (params: { CONTRACT_NAME: string[] }) => ({
      name: ANALYTICS_EVENTS.WITHDRAW_FROM_CONTRACT_ELIGIBILITY_EXPIRED_BANNER_SHOWN,
      parameters: { CONTRACT_NAME: params.CONTRACT_NAME },
    }),
  [ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_SCREEN_VIEW]: (params: {
    SITE: string
    CONTRACT_COUNT: number
    TOTAL_OUTSTANDING_BALANCE: string
    CURRENCY: string
  }) => ({
    name: ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_SCREEN_VIEW,
    parameters: {
      SITE: params.SITE,
      CONTRACT_COUNT: params.CONTRACT_COUNT,
      TOTAL_OUTSTANDING_BALANCE: params.TOTAL_OUTSTANDING_BALANCE,
      CURRENCY: params.CURRENCY,
    },
  }),
  [ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_BANK_ACCOUNT_COPY_BUTTON_CLICK]:
    (params: { SITE: string }) => ({
      name: ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_BANK_ACCOUNT_COPY_BUTTON_CLICK,
      parameters: { SITE: params.SITE },
    }),
  [ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_CANCEL_BUTTON_CLICK]: (params: {
    SITE: string
    CONTRACT_COUNT: number
    TOTAL_OUTSTANDING_BALANCE: string
  }) => ({
    name: ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_CANCEL_BUTTON_CLICK,
    parameters: {
      SITE: params.SITE,
      CONTRACT_COUNT: params.CONTRACT_COUNT,
      TOTAL_OUTSTANDING_BALANCE: params.TOTAL_OUTSTANDING_BALANCE,
    },
  }),
  [ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_CONFIRM_BUTTON_CLICK]: (params: {
    SITE: string
    CONTRACT_COUNT: number
    TOTAL_OUTSTANDING_BALANCE: string
    CURRENCY: string
  }) => ({
    name: ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_CONFIRM_BUTTON_CLICK,
    parameters: {
      SITE: params.SITE,
      CONTRACT_COUNT: params.CONTRACT_COUNT,
      TOTAL_OUTSTANDING_BALANCE: params.TOTAL_OUTSTANDING_BALANCE,
      CURRENCY: params.CURRENCY,
    },
  }),
  [ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_TERMINATION_API_RESPONSE]: (params: {
    SITE: string
    STATUS: 'full_success' | 'partial_success' | 'full_failure'
    SUCCEEDED_COUNT: number
    FAILED_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.CONFIRM_WITHDRAWAL_TERMINATION_API_RESPONSE,
    parameters: {
      SITE: params.SITE,
      STATUS: params.STATUS,
      SUCCEEDED_COUNT: params.SUCCEEDED_COUNT,
      FAILED_COUNT: params.FAILED_COUNT,
    },
  }),
  [ANALYTICS_EVENTS.WITHDRAWAL_SUCCESS_SCREEN_VIEW]: (params: {
    SITE: string
    CONTRACT_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAWAL_SUCCESS_SCREEN_VIEW,
    parameters: { SITE: params.SITE, CONTRACT_COUNT: params.CONTRACT_COUNT },
  }),
  [ANALYTICS_EVENTS.WITHDRAWAL_PARTIAL_FAILURE_SCREEN_VIEW]: (params: {
    SITE: string
    SUCCEEDED_COUNT: number
    FAILED_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAWAL_PARTIAL_FAILURE_SCREEN_VIEW,
    parameters: {
      SITE: params.SITE,
      SUCCEEDED_COUNT: params.SUCCEEDED_COUNT,
      FAILED_COUNT: params.FAILED_COUNT,
    },
  }),
  [ANALYTICS_EVENTS.WITHDRAWAL_FULL_FAILURE_SCREEN_VIEW]: (params: {
    SITE: string
    CONTRACT_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAWAL_FULL_FAILURE_SCREEN_VIEW,
    parameters: { SITE: params.SITE, CONTRACT_COUNT: params.CONTRACT_COUNT },
  }),
  [ANALYTICS_EVENTS.WITHDRAWAL_PARTIAL_FAILURE_RETRY_BUTTON_CLICK]: (params: {
    SITE: string
    FAILED_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAWAL_PARTIAL_FAILURE_RETRY_BUTTON_CLICK,
    parameters: { SITE: params.SITE, FAILED_COUNT: params.FAILED_COUNT },
  }),
  [ANALYTICS_EVENTS.WITHDRAWAL_FULL_FAILURE_RETRY_BUTTON_CLICK]: (params: {
    SITE: string
    FAILED_COUNT: number
  }) => ({
    name: ANALYTICS_EVENTS.WITHDRAWAL_FULL_FAILURE_RETRY_BUTTON_CLICK,
    parameters: { SITE: params.SITE, FAILED_COUNT: params.FAILED_COUNT },
  }),
} as const satisfies Record<
  AnalyticsEventName,
  AnalyticEvent | AnalyticEventFunction
>
